<template>
	<div class="nikan-recaptcha">
		<vue-recaptcha :loadRecaptchaScript="true" :language="$i18n.locale" :sitekey="captchaSiteKey" @error="recaptchaError" @expired="recaptchaError" @verify="recaptchaSuccess"></vue-recaptcha>
	</div>
</template>

<script>
	import { VueRecaptcha } from 'vue-recaptcha'
	export default {
		name: 'nikan-recaptcha',
		emits: ['update:modelValue'],
		components: {
			VueRecaptcha,
		},
		props: {
			modelValue: { type: String, default: '' }
		},
		data() {
			return {
				captchaSiteKey: import.meta.env.VITE_CAPTCHA_SITE_KEY,
			}
		},
		methods: {
			recaptchaError() {
				this.$emit('update:modelValue', '')
			},
			recaptchaSuccess(token) {
				this.$emit('update:modelValue', token)
			}
		}

	}
</script>